import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    isAnimetaVerified: false,
    isSelectAll: false,
    isViewSelect: "grid",
    currentPlatform: 'instagram',
    dataLoader: false,
    isOpenList: false,
    myListpage: 0,
    myListtotalPages: 0,
    myListTotal: 0,
    size: 0,
    listSectionLoader: false,
    shortListData: [],
    listSelectedCreators: [],
    platformLengthData: {},
    isShowNormalizedView:false,
    sort: {
        sortBy: "followers",
        sortOrder: -1,
    },
    campainList: [],
    shortListIndex: 0
}

const myListSlice = createSlice({
    name: 'myList',
    initialState,
    reducers: {
        setMyListData(state, action) {
            state.shortListData = action?.payload?.pagination ? [...state.shortListData, ...action?.payload?.shortListData] : action?.payload?.shortListData;
            state.myListpage = action.payload.myListpage ?? 0;
            state.myListTotal = action.payload.myListTotal ?? 0;
            state.myListtotalPages = action.payload.myListtotalPages ?? 0;
            state.size = action.payload.size ?? 0;
        },
        selectMyListCreator(state, action) {
            state.listSelectedCreators = [...state.listSelectedCreators, action.payload]
        },
        deselectMylistCreator(state, action) {
            state.listSelectedCreators = state.listSelectedCreators.filter(
                (item) => !(item?._id === action.payload?._id && item?.platform === action?.payload?.platform))
        },
        setIsAnimetaVerified(state, action) {
            state.isAnimetaVerified = action.payload
        },
        setIsSelectAll(state, action) {
            state.isSelectAll = action.payload
        },
        setCurrentPlatformData(state, action) {
            state.currentPlatform = action.payload
        },
        setIsViewSelect(state, action) {
            state.isViewSelect = action.payload
        },
        setDataLoader(state, action) {
            state.dataLoader = action.payload
        },
        setIsOpenList(state, action) {
            state.isOpenList = action.payload
        },
        setCreatorShortList(state, action) {
            return { ...state, ...action?.payload }
        },
        setMyListState(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
        clearListSelectedCreators(state, action) {
            state.listSelectedCreators = []
        },

        clearParticularStates(state, action) {
            state.isAnimetaVerified = false;
            state.isSelectAll = false;
            state.isViewSelect = "grid";
            state.currentPlatform = 'instagram';
            state.dataLoader = false;
            state.isOpenList = false;
            state.myListpage = 0;
            state.myListtotalPages = 0;
            state.myListTotal = 0;
            state.size = 0;
            state.listSectionLoader = false;
            state.sort = {
                sortBy: "followers",
                sortOrder: - 1
            }
        },
        clearMyListState(state, action) {
            return initialState;
        }
    }
})
export const myListActions = myListSlice.actions;
export default myListSlice;